import { useFeatureFlags } from '@context/launch-darkly/LDProvider';

const REVIEWS_MIN_COUNT = 3;
const RATING_MIN_COUNT = 3;

export const useShouldShowReviewPage = (
  reviewCount: number,
  ratingSummary: number
) => {
  const { pdHasAllReviewsPage } = useFeatureFlags();

  return (
    reviewCount >= REVIEWS_MIN_COUNT &&
    ratingSummary >= RATING_MIN_COUNT &&
    pdHasAllReviewsPage
  );
};
